import { Container, Box } from '@mui/material';
import React from 'react';
import { BackButton } from '@marageti/z4-lib';
import MyProfileForm from '../../../components/my-profile-form';

const MyProfileView = ({
  loggedInTravelerId,
  navigateToAccount,
}: {
  loggedInTravelerId: string | undefined;
  navigateToAccount: () => void;
}) => {
  if (!loggedInTravelerId) {
    return null;
  }

  return (
    <Container maxWidth="md">
      <Box
        sx={{
          pt: {
            desktop: 6,
            mobile: 3,
          },
          pb: 12,
        }}
      >
        <BackButton onClick={navigateToAccount} edge="start" sx={{ mb: 2 }} />
        <MyProfileForm travelerId={loggedInTravelerId} onCancel={navigateToAccount} onSuccess={navigateToAccount} />
      </Box>
    </Container>
  );
};

export default MyProfileView;
